import { Category, Information } from '../types/header';

/**
 * カテゴリーのモックデータ
 * 将来的にAPIから取得するように変更
 */
export const mockCategories: Category[] = [
  {
    id: '1',
    name: '技術',
    nameEn: 'Technology',
    slug: 'tech',
    isVisible: true,
  },
  {
    id: '2',
    name: '開発',
    nameEn: 'Development',
    slug: 'development',
    isVisible: true,
  },
  {
    id: '3',
    name: 'デザイン',
    nameEn: 'Design',
    slug: 'design',
    isVisible: true,
  },
];

/**
 * インフォメーションのモックデータ
 * 将来的にAPIから取得するように変更
 */
export const mockInformations: Information[] = [
  // 新機能のお知らせはNotificationBannerに移動したため削除
];

